import store from '../../../../store';
export default function checkIfCanUpdate() {
  let exists = false;
  let scopes = store.getters.userScopes;
  if (
    scopes.includes('user_account_update_self') ||
    scopes.includes('user_account_update_all') ||
    scopes.includes('user_account_update_company')
  ) {
    exists = true;
    console.log('CAN UPDATE');
  }
  return exists;
}
